import * as XLSX from 'xlsx';
import { EMENDA_TYPES } from './constants';

/**
 * Exporta dados de emendas para Excel
 * @param {Array} data - Dados a serem exportados
 * @param {Array} columns - Colunas da tabela
 * @param {string} emendaType - Tipo de emenda (municipal ou estadual)
 */
export const exportToExcel = (data, columns, emendaType = EMENDA_TYPES.MUNICIPAL) => {
  const exportData = data.map(row => {
    const cleanRow = {};
    columns.forEach(col => {
      cleanRow[col.header] = row[col.accessorKey];
    });
    return cleanRow;
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);
  
  const colWidths = columns.map(col => ({
    wch: Math.max(col.header.length, 15)
  }));
  ws['!cols'] = colWidths;

  XLSX.utils.book_append_sheet(wb, ws, 'Emendas');
  
  const timestamp = new Date().toISOString().split('T')[0];
  const typeLabel = emendaType === EMENDA_TYPES.ESTADUAL ? 'estaduais' : 'impositivas';
  const fileName = `emendas_${typeLabel}_${timestamp}.xlsx`;
  
  XLSX.writeFile(wb, fileName);
};

/**
 * Exporta dados de emendas para TXT
 * @param {Array} data - Dados a serem exportados
 * @param {Array} columns - Colunas da tabela
 * @param {string} emendaType - Tipo de emenda (municipal ou estadual)
 */
export const exportToTXT = (data, columns, emendaType = EMENDA_TYPES.MUNICIPAL) => {
  const headers = columns.map(col => col.header).join('\t');
  const rows = data.map(row => {
    return columns.map(col => {
      const value = row[col.accessorKey];
      return String(value || '').replace(/\t/g, ' ').replace(/\n/g, ' ');
    }).join('\t');
  });

  const content = [headers, ...rows].join('\n');
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  
  const timestamp = new Date().toISOString().split('T')[0];
  const typeLabel = emendaType === EMENDA_TYPES.ESTADUAL ? 'estaduais' : 'impositivas';
  const fileName = `emendas_${typeLabel}_${timestamp}.txt`;
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
